import addNamespaces from '../../translations/add-namespaces';
import blueprintsEn from '../../translations/blueprints/en.json';
import blueprintsNl from '../../translations/blueprints/nl.json';
import entitiesEn from '../../translations/entities/en.json';
import entitiesNl from '../../translations/entities/nl.json';

addNamespaces('entities', { en: entitiesEn, nl: entitiesNl });
addNamespaces('blueprints', { en: blueprintsEn, nl: blueprintsNl });
